<!-- HelpCenter -->
<template>
  <div class="container">
    <help-list :list="list"></help-list>
  </div>
</template>

<script>
import config from '@/config/config'
import { matches, filter } from 'lodash'
import helpData from './help_config'
import helpDataWatch from './help_config_watch'
import HelpList from './list'

export default {
  components: { HelpList },
  data() {
    return {
      list: [],
      categoryItem: {}
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData () {
      let tempData = []
      switch (this.$route.query.type) {
        case 'watch':
          tempData = helpDataWatch
          break
        default:
          tempData = helpData
      }
      let item = filter(tempData.list, matches({ id: this.$route.query.id }))
      if (!item.length) {
        window.location.href = `${config.siteRoot}/helpcenter?type=${this.$route.query.type}`
      }
      this.categoryItem = item[0]
      this.list = item[0].list
    },
  },
  mounted () {
    if (this.categoryItem.title) document.title = this.categoryItem.title
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";

.container {
  background: #f4f4f8;
  min-height: 100vh;
  box-sizing: border-box;
}

</style>
